// src/js/intersection-observer.js

document.addEventListener("DOMContentLoaded", function () {
    // Targeting elements with the '.pagebuilder-row' class
    const targets = document.querySelectorAll('.pagebuilder-row');
    
    // Check if the targeted elements exist before setting up the Intersection Observer
    if (targets.length > 0) {
        // Function to add the 'fade-in' class to elements
        const fadeInOnScroll = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('fade-in');
                    // Optional: Unobserve the element after adding the class
                    observer.unobserve(entry.target);
                }
            });
        };

        // Creating a new Intersection Observer instance
        const observer = new IntersectionObserver(fadeInOnScroll, {
            root: null, // relative to the viewport
            rootMargin: '0px 0px -10% 0px', // bottom margin of 10% of the viewport height
            threshold: 0 // the callback will execute every time the target meets the rootMargin criteria
        });

        // Observing each target
        targets.forEach(target => {
            observer.observe(target);
        });
    } else {
        // Log a message if no elements are found (optional)
        // console.log("No elements with the class '.pagebuilder-row' were found.");
    }
});
